import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-609b2572"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Regina + Dan", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined lodging-details-icon" }, "menu", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space-behind-nav" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            class: "icon",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, _hoisted_4),
          (_ctx.showMenu)
            ? (_openBlock(), _createElementBlock("br", _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.showMenu)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                onClick: _ctx.toggleMenu,
                to: "/"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Home")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.showMenu)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                onClick: _ctx.toggleMenu,
                to: "/#weddingvideo"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Video")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.showMenu)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 3,
                onClick: _ctx.toggleMenu,
                to: "/#weddingphotos"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Photos")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.showMenu)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                onClick: _ctx.toggleMenu,
                to: "/#engagementvideo"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Engagement")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("nav", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          }),
          _createTextVNode(" | "),
          _createVNode(_component_router_link, { to: "/#weddingvideo" }, {
            default: _withCtx(() => [
              _createTextVNode("Video")
            ]),
            _: 1
          }),
          _createTextVNode(" | "),
          _createVNode(_component_router_link, { to: "/#weddingphotos" }, {
            default: _withCtx(() => [
              _createTextVNode("Photos")
            ]),
            _: 1
          }),
          _createTextVNode(" | "),
          _createVNode(_component_router_link, { to: "/#engagementvideo" }, {
            default: _withCtx(() => [
              _createTextVNode("Engagement")
            ]),
            _: 1
          })
        ])),
    _hoisted_7
  ], 64))
}